import { Button, IconPlus } from '@cmpsr/components';
import { FC } from 'react';
import { type InfoButtonProps } from './types';

export const InfoButton: FC<InfoButtonProps> = ({ onClick }) => (
  <Button
    variant="link-secondary"
    size="s"
    onClick={onClick}
    display="block"
    mt={6}
    whiteSpace="nowrap"
    textDecoration="underline"
    aria-label="Why we ask"
    leadingIcon={
      <IconPlus
        boxSize={5}
        color="text-link-secondary-default"
        background="#FFF"
        padding={0.5}
        borderRadius="radii-1"
      />
    }
  >
    Why we ask
  </Button>
);
